import axios from '@/axios.js'

export default {
  addCashFlow (context, payload) {
    return axios.post('/cashflow', payload)
  },
  getCashFlow (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/cashflow', { params: {
        cashbook_id: payload.cashbookID,
        per_page: payload.perPage,
        page: payload.page,
        search: payload.search,
        type: payload.type
      } })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  findCashFlow (context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`/cashflow/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateCashFlow (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/cashflow/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteCashFlow (context, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/cashflow/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
